import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useRouter } from "next/router";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import ProductCard from "./product-card";
import DoubleHeading from "./double-heading";
import Link from "next/link";

const RelatedProducts = ({ product, relatedProduct }) => {
  const router = useRouter();
  React.useEffect(() => {}, [relatedProduct]);

  const handleRelatedProductsClick = (productName, productSlug, index) => {
    // window.webengage.track("Related Products Clicked", {
    //   "Product slug": product.product_link,
    //   "Product Name": product.name,
    //   "Product URL": router.pathname,
    //   "FPJS ID": localStorage.getItem("FPJS").replace(/"/g, ""),
    //   "Related Product name": productName,
    //   "Related Product Index": index,
    //   "Related Product Slug:": productSlug,
    //   Subdomain: "web.toppersnotes.com",
    // });
  };
  if (!product || !product.relatedProducts || !product.relatedProducts.length)
    return <></>;

  return (
    <div className="bg-white sm:px-0 px-3">
      {relatedProduct ? <DoubleHeading text={"RELATED PRODUCTS"} /> : null}
      <div className="courses-area courses-section pt-50 pb-30">
        <div style={{ margin: "0rem auto" }} className="container">
          <div
            style={{ margin: 0 }}
            className="edemy-grid-sorting row align-items-center"
          >
            <Swiper
              modules={[Pagination]}
              breakpoints={{
                1028: {
                  slidesPerView: 4,
                },
                768: {
                  slidesPerView: 3,
                },
                480: {
                  slidesPerView: 2,
                },
                320: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
              }}
              slidesPerView={4}
              spaceBetween={40}
              pagination={{
                el: ".my-custom-pagination-div",
                clickable: true,
                renderBullet: (index, className) => {
                  return '<span class="' + className + '">' + "</span>";
                },
              }}
              className="mySwiper sm:mt-16 mt-6"
            >
              {relatedProduct
                ? relatedProduct.map((product, index) => (
                    <SwiperSlide key={index}>
                      <div
                        onClick={() => {
                          handleRelatedProductsClick(
                            product.id,
                            product.name,
                            product.product_link,
                            index + 1
                          );
                        }}
                      >
                        {/* <ProductCard product={product} /> */}
                        <div
                        //className="w-1/2 md:w-1/4"
                        >
                          <div className="single-courses-box">
                            <div className="courses-image">
                              <Link href={"/product/" + product.product_link}>
                                <a className="d-block image">
                                  <img
                                    src={product && product.img1}
                                    className="object-contain md:h-72 w-100"
                                    alt="image"
                                  />
                                </a>
                              </Link>
                              <a href="#" className="fav">
                                <i className="flaticon-heart"></i>
                              </a>
                              <div className="price shadow">
                                Rs {product && product.offer_price}
                              </div>
                            </div>
                            <div className="courses-content">
                              {/* <div className="course-author d-flex align-items-center">
                                 <img src="/images/user4.jpg" className="rounded-circle" alt="image" />
                                 <span>James Anderson</span>
                             </div> */}

                              <h3 className="mt-4 h-20 md:h-16 md:mt-0 text-clip overflow-hidden text-left">
                                <Link href={"/product/" + product.product_link}>
                                  <a className="capitalize">{product.name}</a>
                                </Link>
                              </h3>

                              {/* <div className="max-h-10 mt-4 truncate" dangerouslySetInnerHTML={{ __html: unescapeHTML(product.description) }}></div> */}
                              <ul
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                                className="courses-box-footer d-flex"
                              >
                                {product.no_of_books ? (
                                  <li>
                                    <i className="flaticon-agenda"></i>{" "}
                                    {product.no_of_books} Books
                                  </li>
                                ) : (
                                  ""
                                )}
                                {product.rating ? (
                                  <span className="inline-flex rounded-full items-center pl-2.5 pr-1 text-sm font-medium bg-tn-green text-white">
                                    {Math.round(product.rating * 10) / 10}
                                    <button
                                      type="button"
                                      className="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center "
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5 text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                      </svg>
                                    </button>
                                  </span>
                                ) : null}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))
                : null}
            </Swiper>
          </div>
        </div>
      </div>

      <div
        style={{ textAlign: "center", marginBottom: "2rem" }}
        className="my-custom-pagination-div"
      />
    </div>
  );
};

React.memo(RelatedProducts, (preProps, nextProps) => {
  if (JSON.stringify(preProps.product) !== JSON.stringify(nextProps.product))
    return true;
  return false;
});

export default React.memo(RelatedProducts);
